export function toCapitalize(text = "", splitBy = " ") {
    const words = text.split(splitBy);

    const transformWords = words.map(
        (word) =>
            (word[0] ?? "").toUpperCase() + word.slice(1).toLocaleLowerCase(),
    );

    return transformWords.join(splitBy);
}
